import Axios from "axios";
import {
    SET_PRD_PRODUCTION_RECEIVE_LIST,
    UNSET_PRD_PRODUCTION_RECEIVE_LIST,
} from "@/store/mutation-types";
import { 
    saveUpdateInvProductionReceive,
    getInvProductionReceiveList,
    getInvProductionReceiveById,
} from "@/store/api";

const state = {
    getInvProductionReceiveList: [],
};

const getters = {
    getInvProductionReceiveList(state) {
        return state.getInvProductionReceiveList;
    },
};

const mutations = {
    [SET_PRD_PRODUCTION_RECEIVE_LIST](state, data) {
        state.getInvProductionReceiveList = data;
    },
    [UNSET_PRD_PRODUCTION_RECEIVE_LIST](state) {
        state.getInvProductionReceiveList = [];
    },
};

const actions = {

    saveUpdateInvProductionReceive({ commit }, data) {
        commit("SET_LOADING", { color: "primary" })
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateInvProductionReceive, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then(() => {
                    commit("UNSET_LOADING");
                })
        })
    },

    getInvProductionReceiveList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.post(getInvProductionReceiveList)
            .then(function (response) {
            commit('SET_PRD_PRODUCTION_RECEIVE_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_PRD_PRODUCTION_RECEIVE_LIST');
            reject(error);
            });
        });
    },

    getInvProductionReceiveById({ commit }, data) {
        const fullUrl = `${getInvProductionReceiveById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.post(fullUrl)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

